const siteOrigin = 'https://mayonlab.com.ph'
const socialImagePath = '/social/mayon-clinic-social.jpg'
const socialImageUrl = `${siteOrigin}${socialImagePath}`

const routeManifest = {
  home: {
    path: '/',
    title: 'Diagnostic Laboratory in Quezon City | Mayon',
    description: 'Mayon Clinical Laboratory offers affordable laboratory tests, medical packages, drug testing, imaging inquiries, consultations, and selected HMO support through two Quezon City branches.',
    canonical: `${siteOrigin}/`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'Diagnostic Laboratory in Quezon City | Mayon',
    socialDescription: 'Affordable laboratory tests, medical packages, drug testing, imaging inquiries, consultations, and selected HMO support in Quezon City.'
  },

  packages: {
    path: '/packages',
    title: 'Medical and Wellness Packages in Quezon City | Mayon',
    description: 'Compare Mayon laboratory and wellness Packages 1–4, including listed prices, savings, test inclusions, and branch inquiry options in Quezon City.',
    canonical: `${siteOrigin}/packages`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'Medical and Wellness Packages in Quezon City | Mayon',
    socialDescription: 'Compare Mayon laboratory and wellness Packages 1–4, including listed prices, savings, test inclusions, and branch inquiry options in Quezon City.'
  },
  services: {
    path: '/services',
    title: 'Laboratory Tests and Diagnostic Services in Quezon City | Mayon',
    description: 'Browse Mayon laboratory tests, diagnostic services, imaging inquiries, drug testing, vaccines, consultations, and reference prices in Quezon City.',
    canonical: `${siteOrigin}/services`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'Laboratory Tests and Diagnostic Services in Quezon City | Mayon',
    socialDescription: 'Browse Mayon laboratory tests, diagnostic services, imaging inquiries, drug testing, vaccines, consultations, and reference prices in Quezon City.'
  },
  branches: {
    path: '/branches',
    title: 'Mayon Laboratory Branches in Quezon City',
    description: 'Find Mayon Clinical Laboratories branch addresses, contact numbers, schedules, directions, and available service information in Quezon City.',
    canonical: `${siteOrigin}/branches`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'Mayon Laboratory Branches in Quezon City',
    socialDescription: 'Find Mayon branch addresses, contact numbers, schedules, directions, and service information in Quezon City.'
  },
  branchMain: {
    path: '/branches/main',
    title: 'Mayon Main Branch, Quezon City | Laboratory Services',
    description: 'Visit Mayon Main Branch at #857 Lot 3 Mayon St., Brgy. Amoranto, Quezon City for laboratory tests, medical packages, drug testing, and consultation inquiries.',
    canonical: `${siteOrigin}/branches/main`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'Mayon Main Branch, Quezon City | Laboratory Services',
    socialDescription: 'Address, schedule, contact details, directions, and service information for Mayon Main Branch in Quezon City.'
  },
  branchMPlace: {
    path: '/branches/m-place',
    title: 'Mayon M Place Branch, Quezon City | Laboratory Services',
    description: 'Visit Mayon M Place Branch at #116 Ground Floor, SMDC M Place, Panay Ave., Quezon City for laboratory tests, packages, imaging inquiries, and HMO support.',
    canonical: `${siteOrigin}/branches/m-place`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'Mayon M Place Branch, Quezon City | Laboratory Services',
    socialDescription: 'Address, schedule, contact details, directions, and service information for Mayon M Place Branch in Quezon City.'
  },
  hmoPartners: {
    path: '/hmo-partners',
    title: 'HMO Partners and Laboratory Accreditation | Mayon',
    description: 'Review selected HMO partners, laboratory accreditations, and quality affiliations associated with Mayon Clinical Laboratories, subject to branch confirmation.',
    canonical: `${siteOrigin}/hmo-partners`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'HMO Partners and Laboratory Accreditation | Mayon',
    socialDescription: 'Review selected HMO partners, laboratory accreditations, and quality affiliations associated with Mayon Clinical Laboratories, subject to branch confirmation.'
  },
  about: {
    path: '/about',
    title: 'About Mayon Clinical Laboratory and Medical Services | Serving Since 2004',
    description: 'Learn about Mayon Clinical Laboratory and Medical Services, its history since 2004, diagnostic care commitments, quality standards, accreditations, facilities, and patient support in Quezon City.',
    canonical: `${siteOrigin}/about`,
    robots: 'index,follow,max-image-preview:large',
    image: socialImageUrl,
    socialTitle: 'About Mayon Clinical Laboratory and Medical Services | Serving Since 2004',
    socialDescription: 'Learn about Mayon Clinical Laboratory and Medical Services, its history since 2004, diagnostic care commitments, quality standards, accreditations, facilities, and patient support in Quezon City.'
  }
}

module.exports = { siteOrigin, socialImagePath, socialImageUrl, routeManifest, indexableRouteKeys: ['home', 'about', 'packages', 'services', 'hmoPartners', 'branches', 'branchMain', 'branchMPlace'] }
